import type { TrackScreenName } from './types';

export const ROUTE_TO_SCREEN: ReadonlyArray<{
  pattern: string;
  screen: TrackScreenName;
}> = [
  { pattern: '/dashboard', screen: 'homepage' },
  { pattern: '/home', screen: 'homeLandingPage' },
  {
    pattern: '/booking-cleaning/enter-location-and-time',
    screen: 'enterYourAddressPage',
  },
  {
    pattern: '/booking-cleaning/home-description',
    screen: 'aboutYourHomePage',
  },
  { pattern: '/booking-cleaning', screen: 'bookingDetailsPage' },
  {
    pattern: '/booking-cleaning/hours-and-cleaner-selection',
    screen: 'numberOfHoursPage',
  },
  { pattern: '/booking-cleaning/cleaner-list', screen: 'cleanerListPage' },
  { pattern: '/booking-cleaning/package-detail', screen: 'cleanerDetailPage' },
  {
    pattern: '/booking-cleaning/available-date-time',
    screen: 'selectDateTimePage',
  },
  { pattern: '/bookings/$id/payment', screen: 'paymentPage' },
  {
    pattern: '/booking-cleaning/payment/success-info',
    screen: 'bookingCompletedPage',
  },
  { pattern: '/my-wallet', screen: 'myWalletPage' },
  { pattern: '/bookings', screen: 'myCleaningsPage' },
  { pattern: '/favorites', screen: 'favoritesPage' },
  { pattern: '/booking-cleaning/payment', screen: 'paymentErrorMessagePage' },
  {
    pattern: '/apply-cleaner/background-check',
    screen: 'cleanerBackgroundCheckPage',
  },
];

/**
 * Resolve a pathname to a screenName.
 *
 * Match order:
 *   1. Exact pattern match
 *   2. Dynamic segment normalization — each non-empty segment is tried as
 *      `$id`, so `/bookings/abc-123/payment` matches `/bookings/$id/payment`
 *   3. Longest-prefix fallback with a segment boundary
 *      (e.g. `/booking-cleaning/payment/error` falls back to
 *      `/booking-cleaning/payment` → paymentErrorMessagePage). The root
 *      pattern `/` is excluded from prefix matching.
 */
export function resolveScreenName(
  pathname: string
): TrackScreenName | undefined {
  const exact = ROUTE_TO_SCREEN.find(r => r.pattern === pathname);
  if (exact) return exact.screen;

  const segments = pathname.split('/').filter(Boolean);
  for (let i = 0; i < segments.length; i++) {
    const candidate = [...segments];
    candidate[i] = '$id';
    const dynPattern = `/${candidate.join('/')}`;
    const dynMatch = ROUTE_TO_SCREEN.find(r => r.pattern === dynPattern);
    if (dynMatch) return dynMatch.screen;
  }

  const prefix = ROUTE_TO_SCREEN.filter(
    r => r.pattern !== '/' && pathname.startsWith(`${r.pattern}/`)
  ).sort((a, b) => b.pattern.length - a.pattern.length)[0];
  return prefix?.screen;
}
